import { render, staticRenderFns } from "./SubTitleCard.vue?vue&type=template&id=31513bca&"
import script from "./SubTitleCard.vue?vue&type=script&lang=js&"
export * from "./SubTitleCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports